import React, { useEffect, useState, Fragment } from "react";
import FilterResults from "react-filter-search";

import { getStudents } from "../../../../../services/NexiDigitalAPI";

import AccordionItens from "./AccordionItens";
import _ from "underscore";
import { Form } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import CircularProgress from "@material-ui/core/CircularProgress";
import DataTable from "react-data-table-component";

const StudentsItens = ({ idCompanySelected }) => {
  const [students, setStudents] = useState();
  const [currentUser, setCurrentUser] = useState("");
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    offset: 0,
    limit: 10,
    totalRecords: 999,
  });

  const getData = async () => {
    setLoading(true);
    const containerApi = await getStudents(
      idCompanySelected,
      pagination.limit,
      pagination.offset,
      currentUser || undefined,
    );
    setStudents(containerApi.result);
    setPagination((prev) => ({ ...prev, totalRecords: containerApi.totalRecords }));
    setLoading(false);
  };

  const subimitSearch = (e) => {
    e.preventDefault();
    if (pagination.offset === 0) {
      getData();
    } else {
      setPagination((prev) => ({ ...prev, offset: 0 }));
    }
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Usuários por página",
    rangeSeparatorText: "de",
  };

  const onChangePage = (page) => {
    setPagination((prev) => ({ ...prev, offset: --page * prev.limit }));
  };

  const onChangeRowsPerPage = (limit) => {
    setPagination((prev) => ({ ...prev, limit, offset: 0 }));
  };

  useEffect(() => {
    if (idCompanySelected !== -1) {
      getData();
    }
  }, [idCompanySelected, pagination.offset, pagination.limit]);

  return students === undefined ? (
    "Carregando..."
  ) : (
    <>
      <div className="form-group">
        <div className="card">
          <div className="card-body template-card-body">
            <div className="input-container">
              <Form
                onSubmit={subimitSearch}
                className="input-group col-md-8"
                style={{ alignItems: "center", padding: 0 }}
              >
                <input
                  type="text"
                  className="form-control input-default"
                  id="groupDetail"
                  style={{ marginRight: 8 }}
                  aria-describedby="usuario"
                  value={currentUser}
                  onChange={(e) => setCurrentUser(e.target.value)}
                  placeholder="Procurar por usuário"
                />
                <button type="submit" disabled={loading} className="btn btn-primary">
                  <SearchIcon style={{ height: 18 }} /> Pesquisar{" "}
                  {loading && (
                    <CircularProgress
                      size={18}
                      style={{ margin: "0px 0px -3px 10px", color: "white" }}
                    />
                  )}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <div className="arcondeonStudents">
        <FilterResults
          value=""
          data={students}
          renderResults={(results) => (
            <>
              {results.length === 0 && !loading && <p>Não foi encontrado nenhum dado</p>}
              {results.map((item, i) => {
                return (
                  <Fragment key={item.idUser}>
                    <AccordionItens
                      model={"students"}
                      item={item}
                      idUser={item.idUser}
                      indKey={item.idUser}
                      endPoint={0}
                      nodeCode={0}
                      idEnrollment={item.idEnrollment}
                    />
                  </Fragment>
                );
              })}
              <DataTable
                className="d-none"
                data={students}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                paginationTotalRows={pagination.totalRecords}
                paginationComponentOptions={paginationComponentOptions}
                paginationServer
                pagination
              />
            </>
          )}
        />
      </div>
    </>
  );
};

export default StudentsItens;
